/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */
import { CompanyTypesEnum } from '@truckstop-tms/zuum-lib';

export interface Plan {
  id: number;
  type: CLIENT_PLAN_TYPES;
  name: string;
  tmsEnabled: boolean;
  companyType: CompanyTypesEnum;
  price: number;
}

export enum CLIENT_PLAN_TYPES {
  NINJA = 'NINJA',
  TRUCKSTOP_AUTOMATED_BROKER = 'TRUCKSTOP_AUTOMATED_BROKER',
  TRUCKSTOP_AUTOMATED_BROKER_PRO = 'TRUCKSTOP_AUTOMATED_BROKER_PRO',
  // TRUCKSTOP_AUTOMATED_BROKER_ENTERPRISE = 'TRUCKSTOP_AUTOMATED_BROKER_ENTERPRISE',
  TRUCKSTOP_CAPACITY_PRO = 'TRUCKSTOP_CAPACITY_PRO',
  TRUCKSTOP_BUSINESS = 'TRUCKSTOP_BUSINESS',
  TRUCKSTOP_ENTERPRISE = 'TRUCKSTOP_ENTERPRISE',
  CARRIER = 'CARRIER',
  TRUCKSTOP_FLEET_MANAGER = 'TRUCKSTOP_FLEET_MANAGER',
}
